import PropTypes from 'prop-types';
import React from 'react';

const ColouredText = ({ words: [firstWord, secondWord] }) => (
  <span className="coloured-text">
    <span className="coloured-text__first">{firstWord}</span>
    <span className="coloured-text__second">{secondWord}</span>
  </span>
);

ColouredText.propTypes = {
  words: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default ColouredText;
